import { productPrimaryImageStyles } from "@insite/content-library/Components/ProductPrimaryImage";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(productPrimaryImageStyles, {
    ...productPrimaryImageStyles,
    centeringWrapper: {
        css: css`
            min-height: 300px;
            margin: 0 0;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
                height: auto;
                max-width: 100%;
            }
        `,
    },
    img: {
        css: css`
            cursor: default;
        `,
    },
});
